export default __webpack_public_path__ + "static/media/E-WEB-Goal-05.2f81f050.png";